import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const CalendarIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.4 2.9H11.7V2.2C11.7 1.815 11.385 1.5 11 1.5C10.615 1.5 10.3 1.815 10.3 2.2V2.9H5.70001V2.2C5.70001 1.815 5.38501 1.5 5.00001 1.5C4.61501 1.5 4.30001 1.815 4.30001 2.2V2.9H3.60001C2.82301 2.9 2.20701 3.53 2.20701 4.3L2.20001 13.1C2.20001 13.87 2.82301 14.5 3.60001 14.5H12.4C13.17 14.5 13.8 13.87 13.8 13.1V4.3C13.8 3.53 13.17 2.9 12.4 2.9ZM12.4 12.4C12.4 12.785 12.085 13.1 11.7 13.1H4.30001C3.91501 13.1 3.60001 12.785 3.60001 12.4V6.4H12.4V12.4Z'
      fill={color} />
  </svg>
)

export default CalendarIcon
